export class ItemModelLocation {
    constructor(state, town, code) {
        this.state = state;
        this.town = town;
        this.code = code;
    }
}